import React from 'react';
import { Card, List, Label, Header } from 'semantic-ui-react';
import { TopPerformersDetailDto } from '../../services/dashboard/dashboardService';
import GlassmorphismTheme from '../../styles/glassmorphism';

interface TopPerformersListProps {
  performers: TopPerformersDetailDto[];
  title: string;
  isBest?: boolean;
}

const TopPerformersList: React.FC<TopPerformersListProps> = ({ performers, title, isBest = true }) => {
  if (performers.length === 0) {
    return (
      <Card style={{ ...GlassmorphismTheme.components.glassCard, width: '100%' }}>
        <Card.Content>
          <Header as="h3" style={{ color: GlassmorphismTheme.colors.solid.textLight }}>
            {title}
          </Header>
          <p style={{ color: GlassmorphismTheme.colors.solid.textLight, textAlign: 'center', padding: '20px' }}>
            Nenhum dado disponível
          </p>
        </Card.Content>
      </Card>
    );
  }

  return (
    <Card style={{ ...GlassmorphismTheme.components.glassCard, width: '100%' }}>
      <Card.Content>
        <Header as="h3" style={{ color: GlassmorphismTheme.colors.solid.textLight, marginBottom: '15px' }}>
          {title}
        </Header>
        <List divided relaxed>
          {performers.map((performer, index) => (
            <List.Item key={performer.userId} style={{ padding: '10px 0' }}>
              <List.Content>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                  <Label 
                    circular 
                    size="small" 
                    color={isBest ? 'green' : 'red'}
                    style={{ marginRight: '10px', minWidth: '24px', textAlign: 'center' }}
                  >
                    {index + 1}
                  </Label>
                  <strong style={{ color: GlassmorphismTheme.colors.solid.textLight, fontSize: '1em' }}>
                    {performer.userName}
                  </strong>
                </div>
                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: 'repeat(2, 1fr)', 
                  gap: '8px',
                  fontSize: '0.85em',
                  color: GlassmorphismTheme.colors.solid.textLight,
                  marginTop: '8px'
                }}>
                  <div>
                    <strong>Criados:</strong> {performer.contratosCriados}
                  </div>
                  <div>
                    <strong>Assinados:</strong> {performer.contratosAssinados}
                  </div>
                  <div>
                    <strong>Aprovados:</strong> {performer.contratosAprovados}
                  </div>
                  <div>
                    <strong>Taxa Conversão:</strong>{' '}
                    <Label 
                      size="tiny" 
                      color={isBest ? 'green' : 'orange'}
                      style={{ marginLeft: '5px' }}
                    >
                      {performer.taxaConversao.toFixed(1)}%
                    </Label>
                  </div>
                </div>
              </List.Content>
            </List.Item>
          ))}
        </List>
      </Card.Content>
    </Card>
  );
};

export default TopPerformersList;

